import { Action, createReducer, on } from '@ngrx/store'
import { SeasonsState } from '@features/seasons/models/seasons.state'
import {
  purgeSeasons,
  setCurrentSeason,
  setNoCompetitions,
  setSeasonsByContext
} from '@features/seasons/state/actions/seasons.actions'

const initialState: SeasonsState = {
  callingContext: undefined
}

export const reducer = createReducer(
  initialState,

  on(setSeasonsByContext, (state, { callingContext, seasons }) => ({
    ...state,
    [callingContext]: { ...state[callingContext], list: seasons },
    callingContext
  })),
  on(setCurrentSeason, (state, { current, callingContext, keepOriginalOnExist }) => ({
    ...state,
    [callingContext]: {
      ...state[callingContext],
      current: keepOriginalOnExist && state[callingContext].current ? state[callingContext].current : current
    }
  })),

  on(setNoCompetitions, (state) => ({ ...state, noCompetitions: true })),

  on(purgeSeasons, () => ({ ...initialState }))
)

export const seasonsReducer = (state: SeasonsState | undefined, action: Action) => reducer(state, action)
